import React from 'react';
import { Modal } from 'react-bootstrap'

export default function ErrorModal({showMe, hideMe, error}) {
  return (
    <Modal show={showMe} size='lg' onHide={hideMe}>
        <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <p>{ error }</p>
        </Modal.Body>
    </Modal>
  )
}
